import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Platform } from 'ionic-angular';
import { ExtraProvider } from '../../providers/extra/extra';
import { ToastProvider } from '../../providers/toast/toast';
import { Ng2ImgToolsService } from 'ng2-img-tools';
import { TranslateService } from '@ngx-translate/core';


@IonicPage()
@Component({
  selector: 'page-add-member',
  templateUrl: 'add-member.html',
})
export class AddMemberPage {

  name: string = null;
  mobile: number = null;
  email:string = null;
  relation: string = null;
  vehicle: string = null;
  loading = false;
  imgUrl: any = null;
  editPage = false;
  id: number = null;
  selRegistrationLogin : any;
 

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private extra: ExtraProvider,
    private toast: ToastProvider,
    private ref: ChangeDetectorRef,
    private translate: TranslateService,
    private loadingCtrl: LoadingController,
    private platform: Platform,
    private imageTools: Ng2ImgToolsService) {
      this.selRegistrationLogin = localStorage.getItem('signup_login')

  
      let data = navParams.get("data");
      if(data){
        this.editPage = true;
        this.id = data.id;
        this.name = (data.name)?data.name:null;
        this.mobile = (data.phone_no)?data.phone_no:null;
        this.email = (data.email)?data.email:null;
        this.relation = (data.relation)?data.relation:null;
        this.vehicle = (data.vehicle_no)?data.vehicle_no:null;
        this.imgUrl = (data.image_src)?data.image_src:null;
      }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddMemberPage');
  }

  onSubmit(){

    if(this.selRegistrationLogin){
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    }
else{

    let loader = this.loadingCtrl.create({});
    loader.present().then(() => {
      if(this.validate()){
        if(this.editPage){
          let data  = {
            id: this.id,
            name: this.name,
            phone_no: this.mobile,
            email: this.email,
            relation: this.relation,
            vehicle_no: this.vehicle,
            image_src: this.imgUrl
          }
          this.extra.editFamilyMember(data).then(val => {
            this.toast.presentToast(val.message);
            loader.dismiss();
            this.navParams.get("parentPage").refresh();
            this.navCtrl.pop();
          }).catch(val => {
            loader.dismiss();
          });
        }else{
          let data  = {
            name: this.name,
            phone_no: this.mobile,
            email: this.email,
            relation: this.relation,
            vehicle_no: this.vehicle,
            image_src: this.imgUrl
          };
          this.extra.addFamilyMember(data).then(val => {
            this.toast.presentToast(val.message);
            loader.dismiss();
            this.navParams.get("parentPage").refresh();
            this.navCtrl.pop();
          }).catch(val => {
            loader.dismiss();
          });
        }
      }else{
        loader.dismiss();
      }
    });
  }
  }

  validate(){
    if(!this.name || !this.relation){
      if(!this.name){
        this.toast.presentToast("Provide a name");
      }else if(!this.relation){
        this.toast.presentToast("Provide a relation");
      }
      return false;
    }else {
      if(!this.email && !this.mobile){
        this.toast.presentToast("Provide an email or phone no.")
        return false;
      }
      // if(this.mobile && (this.mobile < 1000000000 || this.mobile > 10000000000)){
      //   this.toast.presentToast("Invalid mobile number");
      //   return false;
      // }
      if(this.email && !this.validateEmail(this.email)){
        this.toast.presentToast("Invalid email");
        return false;
      }
      return true;
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  fileChoose(){
    if(this.platform.is('ios')){
      this.extra.imgPicker().then(val => {
        var file = 'data:image/jpeg;base64,' + val[0]
        this.uploadFile(file);
      });
    }else{
      this.extra.chooseFile().then(val => {
        val.fileEntry.getMetadata(metadata => {
          if(metadata.size < 2000000){
            if(val.file && (val.file.slice(-3) == "jpg" || val.file.slice(-3) == "png" || val.file.slice(-4) == "jpeg")){
              this.uploadFile(val)
            }else{
              this.toast.presentToast("file should be an image");
            }
          }else {
            this.toast.presentToast("file size is greater than 2mb");
          }
        });
      });
    }
  }

  getFileName(link){
    return link.slice(link.lastIndexOf('/')+1);
  }

  uploadFile(val){
    //this.toggleLoading();
    console.log(this.loading);
    this.extra.uploadFile(val.base64File, "member", 'ism-complaint-mirror').then(val => {
      console.log(val);
      if(val.status == "success"){
        this.setImage(val.data.url);
      }else{
        this.toast.presentToast(val.message);
      }
      this.toggleLoading();
      console.log(this.loading);
    });
  }

  changeListener($event) : void {
    this.readThis($event.target);
  }
 
  readThis(inputValue: any): void {
    var file:File = inputValue.files[0];
    this.toggleLoading();
    this.imageTools.resize([file], 500, 500).subscribe(val => {
      var reader = new FileReader();
      reader.readAsDataURL(val); 
      reader.onloadend = () => {
        let base64 = reader.result;
        this.uploadFile({base64File: base64});
      }
    }, err => {
      console.log(err);
      this.toggleLoading();
      this.toast.presentToast("Unable to compress");
    });
  }

  toggleLoading(){
    this.loading = !this.loading;
    this.ref.detectChanges();
  }

  setImage(data){
    this.imgUrl = data;
    this.ref.detectChanges();
  }

  closeImg(){
    this.imgUrl = null;
    this.ref.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-member/add-member.ts